import React, { Fragment } from 'react';
import { Box, Heading } from 'roo-ui/components';
import RoomTypeDetails from './RoomTypeDetails';
import OfferDetails from './OfferDetails';
import OfferInclusions from './OfferInclusions';
import CancellationPolicy from './CancellationPolicy';
import RoomDescription from './RoomDescription';

const RoomDetails = () => {
  return (
    <Fragment>
      <Heading.h3 fontSize={['base', 'md']} color="greys.charcoal" mb={4}>
        Room details
      </Heading.h3>
      <Box>
        <RoomTypeDetails />
        {' - '}
        <OfferDetails />
      </Box>
      <Box>
        <CancellationPolicy />
      </Box>
      <Box>
        <RoomDescription />
      </Box>
      <OfferInclusions />
    </Fragment>
  );
};

export default RoomDetails;
